const mediaItems = [
  {
    title: '星辰变',
    desc: '少年秦羽逆天改命，星辰之力撼动三界，史诗级修仙热血漫画全卷完结',
    tag: '修仙热血',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20cultivation%20scene%20with%20a%20young%20warrior%20surrounded%20by%20cosmic%20energy%20and%20stars%2C%20dramatic%20composition%2C%20Chinese%20manhua%20art%20style%2C%20warm%20golden%20and%20crimson%20lighting%2C%20dynamic%20action%20pose%2C%20celestial%20background%20with%20nebula%20effects%2C%20bold%20linework%2C%20vibrant%20colors&width=600&height=800&seq=media-01&orientation=portrait',
  },
  {
    title: '灵笼',
    desc: '末日废土世界生存之战，人类最后的希望灯塔，科幻悬疑漫画完结版',
    tag: '科幻悬疑',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20post%20apocalyptic%20sci%20fi%20scene%20with%20a%20floating%20city%20and%20mysterious%20creatures%2C%20dark%20atmospheric%20lighting%2C%20Chinese%20manhua%20style%2C%20dramatic%20contrast%20of%20light%20and%20shadow%2C%20detailed%20mechanical%20designs%2C%20orange%20and%20teal%20color%20palette%2C%20cinematic%20wide%20shot&width=600&height=800&seq=media-02&orientation=portrait',
  },
  {
    title: '一人之下',
    desc: '异人世界暗流涌动，张楚岚踏上异人之路，都市异能漫画全卷热更中',
    tag: '都市异能',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20urban%20fantasy%20scene%20with%20a%20young%20man%20using%20supernatural%20powers%20in%20a%20city%20alley%2C%20dynamic%20martial%20arts%20pose%2C%20Chinese%20manhua%20style%2C%20neon%20lights%20and%20spiritual%20energy%20effects%2C%20warm%20orange%20accents%2C%20dramatic%20perspective%2C%20bold%20brushwork&width=600&height=800&seq=media-03&orientation=portrait',
  },
  {
    title: '狐妖小红娘',
    desc: '前世今生的姻缘牵绊，涂山狐妖红线仙的浪漫传说，玄幻恋爱漫画经典',
    tag: '玄幻恋爱',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20romantic%20fantasy%20scene%20with%20a%20beautiful%20fox%20spirit%20girl%20in%20traditional%20Chinese%20dress%2C%20cherry%20blossom%20petals%20floating%2C%20soft%20warm%20pink%20and%20golden%20lighting%2C%20Chinese%20manhua%20art%20style%2C%20dreamy%20atmosphere%2C%20elegant%20composition%2C%20delicate%20linework&width=600&height=800&seq=media-04&orientation=portrait',
  },
  {
    title: '镇魂街',
    desc: '人灵共存的镇魂街世界，守护灵觉醒激燃对决，热血战斗漫画完整版',
    tag: '热血战斗',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20intense%20battle%20scene%20with%20two%20powerful%20guardian%20spirits%20clashing%2C%20dynamic%20speed%20lines%20and%20impact%20effects%2C%20Chinese%20manhua%20style%2C%20dramatic%20crimson%20and%20gold%20lighting%2C%20ancient%20Chinese%20architecture%20background%2C%20bold%20action%20composition%2C%20powerful%20energy%20bursts&width=600&height=800&seq=media-05&orientation=portrait',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            精彩推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选热门漫画完整版，下拉式阅读一次性看完全卷
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group cursor-pointer">
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3">
                <img
                  src={item.imageUrl}
                  alt={`${item.title}漫画推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center">
                  <i className="ri-play-fill text-white text-lg"></i>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="inline-block px-2 py-0.5 bg-accent-500/90 text-white text-xs font-medium rounded-full mb-1.5">
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-base font-bold text-white">{item.title}</h3>
                </div>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}